/**
 * Wire types for POST /ads/intents/batch-apply (body + success payload).
 * Keep in sync with `api/dashboard/customer/.../batchApplyIntents/handler.ts`.
 */

export type BatchIntentApplyOperation = {
  campaign_id: string;
  intent_ids: string[];
};

/** Publish polling fields — prefer `publish_update_targets` for mapping polls to campaigns; `update_ids` alone is only safe for single-operation batches (see `collectBatchIntentApplyUpdateTargets`). */
export type BatchIntentApplyResponse = {
  update_ids?: string[];
  publish_update_targets?: Array<{
    campaign_id: string;
    update_id: string;
  }>;
};

export type BatchIntentApplyApiResponse = BatchIntentApplyResponse & {
  intent_ids?: string[];
  applied?: number;
  errors?: string[];
  message?: string;
};

/** Nothing applied but API returned error strings — treat as failure before polling. */
export function getBatchApplyHardFailureMessage(
  response: BatchIntentApplyApiResponse
): string | null {
  const applied = response.applied ?? 0;
  const errors = response.errors;
  if (applied < 1 && Array.isArray(errors) && errors.length > 0) {
    return errors.join("; ");
  }
  return null;
}

/** Some intents applied but there were per-operation errors — optional UX hint. */
export function getBatchApplyPartialWarningMessage(
  response: BatchIntentApplyApiResponse
): string | null {
  const applied = response.applied ?? 0;
  const errors = response.errors;
  if (applied >= 1 && Array.isArray(errors) && errors.length > 0) {
    const sample = errors.slice(0, 3).join("; ");
    return errors.length > 3 ? `${sample}…` : sample;
  }
  return null;
}
